import { Box } from '@radix-ui/themes';
import { ReactNode } from 'react';

export interface SuggestionDropdownProps<T> {
    items: T[];
    highlightedIndex: number;
    onSelect: (item: T) => void;
    onHighlight: (index: number) => void;
    renderItem: (item: T, isHighlighted: boolean) => ReactNode;
    highlightColor?: string;
}

export const SuggestionDropdown = <T,>({
    items,
    highlightedIndex,
    onSelect,
    onHighlight,
    renderItem,
    highlightColor = 'var(--gray-a3)',
}: SuggestionDropdownProps<T>) => {
    if (items.length === 0) return null;

    return (
        <Box
            style={{
                position: 'absolute',
                top: 'calc(100% + 4px)',
                left: 0,
                right: 0,
                backgroundColor: 'var(--color-background)',
                border: '1px solid var(--gray-a6)',
                borderRadius: 'var(--radius-3)',
                boxShadow: 'var(--shadow-5)',
                zIndex: 50,
                overflow: 'hidden',
            }}
        >
            {items.map((item, index) => {
                const isHighlighted = highlightedIndex === index;

                return (
                    <Box
                        key={String(item)}
                        onMouseDown={(e) => {
                            e.preventDefault();
                            onSelect(item);
                        }}
                        onMouseEnter={() => onHighlight(index)}
                        style={{
                            backgroundColor: isHighlighted
                                ? highlightColor
                                : 'transparent',
                            cursor: 'pointer',
                            transition: 'background-color 0.1s ease',
                        }}
                    >
                        {renderItem(item, isHighlighted)}
                    </Box>
                );
            })}
        </Box>
    );
};
